module.exports = __webpack_public_path__ + "img/Flag_of_Anguilla.795a23a8.svg";